export type AudioCleanupLevel = 'gentle' | 'balanced' | 'clear';
export type AudioToneProfile = 'natural' | 'warm' | 'bright';

export interface BuyerRecordedAudioDraft {
  file: File;
  imageFile?: File | null;
  createdAt: number;
  source: 'recorder' | 'upload';
  noiseCancellation: boolean;
  echoCancellation: boolean;
  autoGain: boolean;
  cleanupLevel: AudioCleanupLevel;
  toneProfile: AudioToneProfile;
}

let buyerRecordedAudioDraft: BuyerRecordedAudioDraft | null = null;

export const setBuyerRecordedAudioDraft = (draft: BuyerRecordedAudioDraft) => {
  buyerRecordedAudioDraft = draft;
};

export const getBuyerRecordedAudioDraft = () => buyerRecordedAudioDraft;

export const consumeBuyerRecordedAudioDraft = () => {
  const draft = buyerRecordedAudioDraft;
  buyerRecordedAudioDraft = null;
  return draft;
};

export const clearBuyerRecordedAudioDraft = () => {
  buyerRecordedAudioDraft = null;
};
